import { Helmet } from 'react-helmet';
import logo from './logo.png';
import splash from './splash.png';
import mainScreen from './main_screen.png';
import filePicker from './filePicker.png';
import confirm from './confirm.png';
import './App.css';

const topUrl = 'https://www.ryujincomputing.co.jp/';

function RcToMp4(ver, privacyPolicy) {
  switch (ver) {
    case "1.0.0":
    case "1.1.0":
    case "1.1.1":
    case "1.1.2":
    case "1.1.3":
      if (privacyPolicy === null) {
        return body(ver);
      }
      return privacyPolicyPage(ver);

    default:
      return noVer();
  }
}

const noVer = () => {
  return <div className="App">
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <p>RcToMp4</p>
          </header>
          <p className="p-indent">
            未知のバージョン指定です。URLパラメータをご確認ください。
          </p>
        </div>;
}

const linkToTop = () => {
  return <a href={topUrl}>龍神コンピューティングのトップページへ</a>;
}

const privacyPolicyPage = (ver) => {
  var appName = "変換名人"

  return <>
          <Helmet>
            <title>{appName}</title>
          </Helmet>
          <div className="App">
            <header className="App-header">
              <img src={logo} className="App-logo" alt="logo" />
              <p>{appName}({ver})</p>
            </header>
            { showPrivacyPolicy(ver)}
            { linkToTop() }
          </div>
        </>;
}

const body = (ver) => {
    var appName = "変換名人"

    return (
      <div className="App">
        <Helmet>
          <title>{appName}</title>
        </Helmet>
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>{appName}({ver})</p>
        </header>
        <div className='usage'>
          <h1 className='h-margin'>概要・使い方</h1>
          <p className="p-indent">
            このアプリはデバイス内に保存されている動画ファイルをMP4やMP3フォーマットに変換するソフトウエアです。楽しい気分になれるよう、ポップアートとともにお届けします。
          </p>
          <p className="p-indent">
            アプリを起動するとスプラッシュ画面が表示された後メイン画面になります。「ファイル選択」ボタンを押して変換対象のファイルを指定してください。
          </p>
          <p className="p-indent">
            対象ファイルを選択すると変換実行画面（兼確認画面）になるので、表示されたファイル名を確認・変換形式を選択して「変換実行」ボタンを押してください。対象ファイルが違った場合は「キャンセル」ボタンを押してメイン画面へ戻ります。
          </p>
          <p className="p-indent">
            変換後のファイルはAndroidの「動画」フォルダー内の「RcToMp4」または「音楽」フォルダー内の「RcToMp3」というフォルダーの中に作られます。元のファイルと同名で拡張子がmp4またはmp3になります。すでに同じ名前のファイルがあった場合はファイル名部分に(2)のようにかっこ数字が付加されます。
          </p>
          <p className="p-indent">
            大きなファイルの変換には時間がかかりますがバックグラウンドで処理を続行できますので、他のアプリを使用してもその間に変換は進みます。画面を消している間も進行します（本当にシャットダウンしているときは動きません）。
          </p>
          <figure>
            <img src={splash} className="splash" alt="splash" />
            <figcaption>スプラッシュ画像</figcaption>
          </figure>

          <h2 className='h-margin'>【メイン画面】</h2>
          <figure>
            <img src={mainScreen} className="back" alt="back" />
            <figcaption>メイン画面</figcaption>
          </figure>
          <p className="p-indent">
            「ウェブページを開く」ボタンを押すとブラウザで当ページを開きます。
          </p>
          <p className="p-indent">
            「ファイル選択」ボタンを押してファイル選択画面へ遷移します。ファイル選択画面はandroidのシステムが提供しているものですので、そちらの使い方を参照してください。
          </p>

          <h2 className='h-margin'>【ファイル選択画面】</h2>
          <figure>
            <img src={filePicker} className="filePicker" alt="filePicker" />
            <figcaption>ファイル選択画面</figcaption>
          </figure>
          <p className="p-indent">
            変換対象のファイルを選択します。（OSのファイル選択画面です。）
          </p>

          <h2 className='h-margin'>【変換実行画面】</h2>
          <figure>
            <img src={confirm} className="confirm" alt="confirm" />
            <figcaption>変換実行画面</figcaption>
          </figure>
          <p className="p-indent">
            画面上部に表示されているファイル名を確認・変換形式を選択して「変換実行」ボタンを押します。ファイルが間違っている場合は「キャンセル」ボタンを押してメイン画面へ戻ります。ボタンの下に変換の進捗を示すプログレスバーがあります。元ファイルの全体再生時間が取得できない場合があり、そのときはプログレスバーは動きませんが処理は行われます。
          </p>
          <p className="p-indent">
            変換結果のファイルはmp4を指定した場合、動画フォルダーの中のRcToMp4フォルダーの中へ、mp3を指定した場合、音楽フォルダーの中のRcToMp3フォルダーの中へ作られます。
          </p>
        </div>
        <div className='playstore'>
          <h1 className='h-margin'>Play&nbsp;Store&nbsp;ページ</h1>
          <p className="p-indent">
            <a href="https://play.google.com/store/apps/details?id=jp.co.ryujincomputing.rctomp4">こちらからダウンロード・インストールしてください。</a>
          </p>
          <p className="p-indent">
            <a href="https://play.google.com/store/apps/details?id=jp.co.ryujincomputing.rcvidplayerlight">姉妹アプリの動画プレイヤーはこちらからどうぞ。</a>
          </p>
        </div>
        <div className='disclaimer'>
          <h1 className='h-margin'>免責事項</h1>
          <p className="p-indent">
            このアプリはファイルの更新や削除は行いませんが、変換結果をデバイス内に保存します。アプリの使用によりデバイスに損傷が生じたり、何らかの被害が発生しても弊社では責任を負えませんのでご了承ください。
          </p>
          <p className="p-indent">
            動画・音声ファイルを指定しているにもかかわらず正常に変換されない場合もあり得ますが個別に対応することはできませんのでご了承ください。
          </p>
        </div>
        { showPrivacyPolicy() }
        { linkToTop() }
        { showBuildHistory(ver) }
        { linkToTop() }
      </div>
    );
}

const showBuildHistory = ver => {

  return <>
      <div className='buildHistory'>
        <h1 className='h-margin'>バージョンと修正等内容</h1>
        <p className="p-indent">
          初回の公開です。
        </p>
      </div>
    </>;
}

const showPrivacyPolicy = ver => {
  return <>
          <div className='privacyPolicy'>
            <h1 className='h-margin'>プライバシーポリシー</h1>
            <p className="p-indent">
              このアプリは、ユーザーの個人情報を収集または保存しません。
            </p>
            <p className="p-indent">
              アプリ内で変換する動画／音声ファイルはユーザーが選択したものであり、外部に送信されることはありません。
            </p>
            <p className="p-indent">
              また、インターネット接続を利用する場合も、利用者の操作に基づいてのみ通信が行われます（広告部分は別途自動通信が発生します）。
            </p>
            <p className="p-indent">
              アプリの名称・バージョン情報、セッション用の情報以外は送信されません。セッション用情報以外の送信された情報はサーバー上に保存されません。
            </p>
          </div>
        </>;
}

export default RcToMp4;
